import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material'
import React, { useState } from 'react'
import EditIcon from '@mui/icons-material/Edit'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const ReneuModel = ({ revenu, updatepage }) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Revenu: revenu,
    },
  })
  const handleClickOpen = () => {
    setValue('Revenu', revenu)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }
  const onSubmit = async (data) => {
    const payload = {
      addb: 'update',
      value1: data.Revenu,
    }
    const response = await makePostRequest('/api/Finance/add-budgetrevenu/', payload, {}, true)
    if (response.status === 200) {
      updatepage()
      handleClose()
    }
  }
  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <EditIcon sx={{ color: 'white' }} />
      </IconButton>

      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{t('finance.monBudget.editIncomeTarget')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Revenu"
              label={t('finance.monBudget.incomeLabel')}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('finance.common.confirm')}</Button>
            <Button onClick={handleClose}>{t('finance.common.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
export default function ManageBox({ revenu, updatepage }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <Box
      color={'white'}
      height={'100%'}
      width={'100%'}
      sx={{
        bgcolor: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 2,
      }}
    >
      <Box p={2} height={'100%'}>
        <Box color={'rgba(255,255,255,0.62)'} fontSize={13} fontWeight={800}>
          {t('finance.monBudget.referenceIncome')}
        </Box>
        <Box color={'rgba(255,255,255,0.48)'} fontSize={12} mt={0.5}>
          {t('finance.monBudget.referenceIncomeSubtitle')}
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          height={'70%'}
          fontSize={'1.8rem'}
          fontWeight={700}
        >
          <Box>{revenu} € </Box>
          <Box>
            <ReneuModel revenu={revenu} updatepage={updatepage} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
